import { IonIcon } from "@ionic/react";
import {
  checkmarkCircleOutline,
  closeCircle,
  volumeMuteOutline,
} from "ionicons/icons";
import { nightModeStyleWhite } from "../publicFunctions/publicHelpers/helpers";
import { muteUser } from "../config/firebase";
import { useState } from "react";
import Lottie from "react-lottie-player";
import loadingAnimation from "../img/animations/loadinganimation.json";

function MuteUser({
  mutedUsers,
  refreshMutedUsers,
  userIdToMute,
  nightMode,
  defaultMessage = "",
}) {
  const [message, setMessage] = useState(defaultMessage ? defaultMessage : "");
  const [loading, setLoading] = useState(false);
  const [showYouSure, setShowYouSure] = useState(false);

  const handleMuteUser = async () => {
    setLoading(true);
    const { data } = await muteUser({
      userIdToMute,
      muteUser:
        userIdToMute && mutedUsers && mutedUsers[userIdToMute] === true
          ? false
          : true,
    });

    if (data?.success) {
      setMessage(
        "Success! You may have to close/re-open tabs for changes to take effect."
      );
      if (data.mutedUsers) {
        refreshMutedUsers(data.mutedUsers);
      } else {
        refreshMutedUsers();
      }
    } else {
      if (data?.message) {
        setMessage(data.message);
      } else {
        setMessage(
          "Hmmm... something went wrong. Please try again in a few minutes."
        );
      }
    }
    setShowYouSure(false);
    setLoading(false);
  };

  const userAlreadyMuted =
    userIdToMute && mutedUsers && mutedUsers[userIdToMute] === true
      ? true
      : false;

  return (
    <div
      style={nightMode ? nightModeStyleWhite : {}}
      className="padding--small"
    >
      {message ? (
        <p className="description center-text max-width--readable-center bold">
          {message}
        </p>
      ) : null}
      <div className="flex justify-content--center">
        {loading ? (
          <div className={"social-icon--large"}>
            <Lottie
              loop
              animationData={loadingAnimation}
              speed={1.5}
              play
            ></Lottie>
          </div>
        ) : showYouSure ? (
          <div className="flex flex--direction-column align-items--center">
            <div className="redraw--youSure align-self--center">
              <p style={nightMode ? nightModeStyleWhite : {}}>Are you sure?</p>
              <IonIcon
                onClick={async (event) => {
                  event.preventDefault();
                  await handleMuteUser();
                }}
                className="im-sure"
                icon={checkmarkCircleOutline}
              />
              <IonIcon
                onClick={() => {
                  setShowYouSure(false);
                }}
                className="not-sure"
                icon={closeCircle}
              />
            </div>
            <p className="description center-text max-width--readable-center">
              {!userAlreadyMuted
                ? "This user will NOT be notified that you muted them. " +
                  "You will no longer see their stories or comments or be notified " +
                  "if they tag you in a post. Writing Battle does not allow bullying " +
                  "or harassement of any kind. If you feel like you're being harassed by this user " +
                  "on our platform, please contact an admin of Writing Battle. " +
                  "You can manage your muted users on your My Account page."
                : ""}
            </p>
          </div>
        ) : (
          <div
            onClick={(event) => {
              event.preventDefault();
              setShowYouSure(true);
              setMessage("");
            }}
            className="flex flex--gap-smaller cursor--pointer"
          >
            <div className="justify-self--end">
              <IonIcon className="social-icon" icon={volumeMuteOutline} />
            </div>
            <p className="description--small bold underline">
              {userAlreadyMuted ? "Unmute User" : "Mute this User"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default MuteUser;
